/* YouPrint — feature scripts (loaded after theme.js) */
/* ==========================================================================
   YouPrint — phase 2: motion, dimension sketch, delivery estimate,
   gallery, terms gate, invoice
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  (function () {
    var els = document.querySelectorAll('[data-reveal],[data-reveal-stagger]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // safety net: never leave content invisible if something goes wrong
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 3000);
  })();

  /* ---- Qatar working-day helpers (weekend = Fri + Sat) ---- */
  function addWorkingDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay(); // 0 Sun .. 6 Sat
      if (day !== 5 && day !== 6) added++;
    }
    return d;
  }
  function fmtDate(d, locale) {
    try {
      return d.toLocaleDateString(locale || document.documentElement.lang || 'en-GB',
        { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1);
    }
  }

  /* ---- Delivery estimate widget ---- */
  document.querySelectorAll('[data-delivery-est]').forEach(function (box) {
    var prodMin = parseInt(box.getAttribute('data-prod-min'), 10) || 8;
    var prodMax = parseInt(box.getAttribute('data-prod-max'), 10) || 12;
    var qaMin = parseInt(box.getAttribute('data-qa-min'), 10) || 1;
    var qaMax = parseInt(box.getAttribute('data-qa-max'), 10) || 2;
    var gccMin = parseInt(box.getAttribute('data-gcc-min'), 10) || 3;
    var gccMax = parseInt(box.getAttribute('data-gcc-max'), 10) || 5;
    var out = box.querySelector('[data-est-out]');
    var region = 'qa';

    function render() {
      var today = new Date();
      var approve = addWorkingDays(today, 1);
      var pMin = addWorkingDays(approve, prodMin);
      var pMax = addWorkingDays(approve, prodMax);
      var dMin = addWorkingDays(pMin, region === 'qa' ? qaMin : gccMin);
      var dMax = addWorkingDays(pMax, region === 'qa' ? qaMax : gccMax);
      var L = box.getAttribute('data-labels');
      var labels;
      try { labels = JSON.parse(L); } catch (e) { labels = {}; }

      out.innerHTML =
        step(labels.approve || 'Artwork approved', labels.approve_sub || 'Upload today, proof back next working day', fmtDate(approve)) +
        step(labels.production || 'Production complete', (prodMin + '–' + prodMax + ' ' + (labels.working_days || 'working days')), fmtDate(pMin) + ' – ' + fmtDate(pMax)) +
        step(labels.delivered || 'Delivered', region === 'qa' ? (labels.in_qatar || 'Anywhere in Qatar') : (labels.in_gcc || 'Across the GCC'), fmtDate(dMin) + ' – ' + fmtDate(dMax));
    }
    function step(title, sub, when) {
      return '<div class="delivery-step"><span class="delivery-step__dot"><i></i></span>' +
             '<span><b>' + title + '</b><br><span>' + sub + '</span></span>' +
             '<time>' + when + '</time></div>';
    }
    box.querySelectorAll('[data-region]').forEach(function (b) {
      b.addEventListener('click', function () {
        region = b.getAttribute('data-region');
        box.querySelectorAll('[data-region]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        render();
      });
    });
    render();
  });

  /* ---- Dimension sketch: isometric box drawn from the selected size ---- */
  document.querySelectorAll('[data-dimsketch]').forEach(function (box) {
    var target = box.getAttribute('data-dimsketch');
    var select = document.getElementById(target);
    var canvas = box.querySelector('[data-dimsketch-svg]');
    var legend = box.querySelector('[data-dimsketch-legend]');
    if (!canvas) return;

    // Everything is presented in centimetres. Values written in mm are converted.
    function toCm(n, isMm) { return isMm ? n / 10 : n; }
    function fmtCm(n) {
      var r = Math.round(n * 10) / 10;
      return (r % 1 === 0 ? r.toFixed(0) : r.toFixed(1)) + ' cm';
    }
    function parseDims(str) {
      if (!str) return null;
      var norm = String(str).replace(/[×✕✖]/g, 'x').replace(/\s+/g, ' ');
      var isMm = /\bmm\b/i.test(norm);
      var m = norm.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (m) return [toCm(+m[1], isMm), toCm(+m[2], isMm), toCm(+m[3], isMm)];
      var d = norm.match(/[Øø]\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (d) return { dia: toCm(+d[1], isMm), len: toCm(+d[2], isMm) };
      var f = norm.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (f) return [toCm(+f[1], isMm), toCm(+f[2], isMm), 0];
      return null;
    }

    var INK = '#00061A', BLUE = '#2757FF', LINE = 'rgba(0,6,26,.55)';

    function dimLine(x1, y1, x2, y2, label, side) {
      var ang = Math.atan2(y2 - y1, x2 - x1);
      var nx = Math.sin(ang) * (side || 1), ny = -Math.cos(ang) * (side || 1);
      var off = 30;
      var ax = x1 + nx * off, ay = y1 + ny * off;
      var bx = x2 + nx * off, by = y2 + ny * off;
      var mx = (ax + bx) / 2, my = (ay + by) / 2;
      var deg = ang * 180 / Math.PI;
      if (deg > 90 || deg < -90) deg += 180;
      return '<path d="M' + x1 + ' ' + y1 + 'L' + ax + ' ' + ay + '" stroke="' + LINE + '" stroke-width="1" stroke-dasharray="3 3"/>' +
             '<path d="M' + x2 + ' ' + y2 + 'L' + bx + ' ' + by + '" stroke="' + LINE + '" stroke-width="1" stroke-dasharray="3 3"/>' +
             '<path d="M' + ax + ' ' + ay + 'L' + bx + ' ' + by + '" stroke="' + BLUE + '" stroke-width="1.6" marker-start="url(#yp-arr)" marker-end="url(#yp-arr)"/>' +
             '<text x="' + mx + '" y="' + (my - 7) + '" transform="rotate(' + deg.toFixed(1) + ' ' + mx + ' ' + my + ')" text-anchor="middle" font-family="Inter,sans-serif" font-size="15" font-weight="500" fill="' + INK + '">' + label + '</text>';
    }

    function drawBox(L, W, H) {
      var VB_W = 660, VB_H = 320;
      // auto-fit the isometric bounding box inside the canvas, leaving room for dimension lines
      var isoW = (L + W) * 0.866;
      var isoH = (L + W) * 0.5 + H;
      var s = Math.min(430 / (isoW || 1), 200 / (isoH || 1));
      var ex = [0.866 * s, 0.5 * s], ey = [-0.866 * s, 0.5 * s], ez = [0, -1 * s];
      function P(l, w, h) { return [l * ex[0] + w * ey[0] + h * ez[0], l * ex[1] + w * ey[1] + h * ez[1]]; }
      var pts = { A: P(0,0,0), B: P(L,0,0), C: P(L,W,0), D: P(0,W,0),
                  A2: P(0,0,H), B2: P(L,0,H), C2: P(L,W,H), D2: P(0,W,H) };
      var xs = [], ys = [];
      Object.keys(pts).forEach(function (k) { xs.push(pts[k][0]); ys.push(pts[k][1]); });
      var cx = VB_W / 2 - (Math.min.apply(null, xs) + Math.max.apply(null, xs)) / 2;
      var cy = VB_H / 2 - (Math.min.apply(null, ys) + Math.max.apply(null, ys)) / 2;
      Object.keys(pts).forEach(function (k) { pts[k] = [pts[k][0] + cx, pts[k][1] + cy]; });
      function pl() {
        return Array.prototype.slice.call(arguments).map(function (k) { return pts[k].join(','); }).join(' ');
      }
      var faceTop = '<polygon points="' + pl('A2','B2','C2','D2') + '" fill="#E0BC92" stroke="' + INK + '" stroke-width="1.6" stroke-linejoin="round"/>';
      var faceR = '<polygon points="' + pl('B','C','C2','B2') + '" fill="#A87B4E" stroke="' + INK + '" stroke-width="1.6" stroke-linejoin="round"/>';
      var faceL = '<polygon points="' + pl('A','B','B2','A2') + '" fill="#C89B6A" stroke="' + INK + '" stroke-width="1.6" stroke-linejoin="round"/>';
      var dims =
        dimLine(pts.A[0], pts.A[1], pts.B[0], pts.B[1], fmtCm(L), 1) +
        dimLine(pts.C[0], pts.C[1], pts.B[0], pts.B[1], fmtCm(W), 1) +
        (H > 0 ? dimLine(pts.C2[0], pts.C2[1], pts.C[0], pts.C[1], fmtCm(H), -1) : '');
      return svgWrap(VB_W, VB_H, faceL + faceR + faceTop + dims);
    }

    function drawTube(dia, len) {
      var VB_W = 660, VB_H = 320;
      var s = Math.min(300 / (dia || 1), 210 / (len || 1));
      var w = dia * s, h = len * s, rx = w / 2, ry = w / 6;
      var x = VB_W / 2 - w / 2, y = VB_H / 2 - h / 2;
      var body = '<path d="M' + x + ' ' + (y + ry) + ' L' + x + ' ' + (y + h - ry) +
        ' A' + rx + ' ' + ry + ' 0 0 0 ' + (x + w) + ' ' + (y + h - ry) +
        ' L' + (x + w) + ' ' + (y + ry) + 'Z" fill="#C89B6A" stroke="' + INK + '" stroke-width="1.6"/>' +
        '<ellipse cx="' + (x + rx) + '" cy="' + (y + ry) + '" rx="' + rx + '" ry="' + ry + '" fill="#E0BC92" stroke="' + INK + '" stroke-width="1.6"/>';
      var dims = dimLine(x, y + h, x + w, y + h, 'Ø ' + fmtCm(dia), 1) +
                 dimLine(x + w, y + ry, x + w, y + h, fmtCm(len), -1);
      return svgWrap(VB_W, VB_H, body + dims);
    }

    function svgWrap(w, h, inner) {
      return '<svg viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Dimension drawing">' +
        '<defs><marker id="yp-arr" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">' +
        '<path d="M1 1 9 5 1 9z" fill="' + BLUE + '"/></marker></defs>' + inner + '</svg>';
    }

    function render() {
      var raw = select ? select.value : box.getAttribute('data-fallback');
      var d = parseDims(raw);
      if (!d) { box.style.display = 'none'; return; }
      box.style.display = '';
      var L_len = box.getAttribute('data-label-length') || 'Length';
      var L_wid = box.getAttribute('data-label-width') || 'Width';
      var L_hei = box.getAttribute('data-label-height') || 'Height';
      var L_dia = box.getAttribute('data-label-diameter') || 'Diameter';
      if (d.dia) {
        canvas.innerHTML = drawTube(d.dia, d.len);
        if (legend) legend.innerHTML = L_dia + ' <b>' + fmtCm(d.dia) + '</b> · ' + L_len + ' <b>' + fmtCm(d.len) + '</b>';
      } else {
        canvas.innerHTML = drawBox(d[0], d[1], d[2]);
        if (legend) {
          legend.innerHTML = L_len + ' <b>' + fmtCm(d[0]) + '</b> · ' + L_wid + ' <b>' + fmtCm(d[1]) + '</b>' +
            (d[2] ? ' · ' + L_hei + ' <b>' + fmtCm(d[2]) + '</b>' : '');
        }
      }
    }
    if (select) select.addEventListener('change', render);
    render();
  });

  /* ---- Gallery filter + lightbox ---- */
  document.querySelectorAll('[data-gallery-root]').forEach(function (root) {
    root.querySelectorAll('[data-gallery-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-gallery-filter');
        root.querySelectorAll('[data-gallery-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        root.querySelectorAll('[data-gallery-tags]').forEach(function (item) {
          item.hidden = !(f === '*' || (' ' + item.getAttribute('data-gallery-tags') + ' ').indexOf(' ' + f + ' ') > -1);
        });
      });
    });
  });

  (function () {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    var body = lb.querySelector('[data-lightbox-body]');
    var cap = lb.querySelector('[data-lightbox-cap]');
    function close() { lb.hidden = true; document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var item = e.target.closest('[data-lightbox-open]');
      if (item) {
        var media = item.querySelector('img, svg');
        if (!media) return;
        body.innerHTML = media.outerHTML;
        cap.textContent = item.getAttribute('data-lightbox-open') || '';
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === lb) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  })();

  /* ---- Cart: terms & conditions gates (all must be ticked) ---- */
  (function () {
    var gates = Array.prototype.slice.call(document.querySelectorAll('[data-terms-gate]'));
    if (!gates.length) return;
    var form = gates[0].closest('form');
    if (!form) return;
    var err = document.querySelector('[data-terms-error]');
    var boxes = gates.map(function (g) { return g.querySelector('input[type="checkbox"]'); }).filter(Boolean);
    var buttons = Array.prototype.slice.call(form.querySelectorAll('[name="checkout"], [data-checkout]'));

    function allTicked() { return boxes.every(function (b) { return b.checked; }); }

    function sync() {
      var ok = allTicked();
      buttons.forEach(function (b) { b.disabled = !ok; });
      if (ok) {
        gates.forEach(function (g) { g.classList.remove('is-error'); });
        if (err) err.classList.remove('is-shown');
      }
    }

    boxes.forEach(function (b) { b.addEventListener('change', sync); });

    form.addEventListener('submit', function (e) {
      var isCheckout = e.submitter && (e.submitter.name === 'checkout' || e.submitter.hasAttribute('data-checkout'));
      if (!isCheckout || allTicked()) return;
      e.preventDefault();
      var first = null;
      gates.forEach(function (g) {
        var b = g.querySelector('input[type="checkbox"]');
        if (b && !b.checked) { g.classList.add('is-error'); if (!first) first = g; }
      });
      if (err) err.classList.add('is-shown');
      if (first) first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });

    sync();
  })();

  /* ---- Invoice print ---- */
  document.querySelectorAll('[data-print]').forEach(function (b) {
    b.addEventListener('click', function () { window.print(); });
  });

  /* ---- Sticky add-to-cart shadow on scroll (subtle polish) ---- */
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if ((y > 8) !== (last > 8)) header.style.boxShadow = y > 8 ? '0 1px 0 rgba(0,6,26,.06), 0 6px 24px rgba(0,6,26,.06)' : '';
      last = y;
    }, { passive: true });
  })();
})();

/* ==========================================================================
   YouPrint — sheet-yield price calculator
   ========================================================================== */
(function () {
  'use strict';
  document.querySelectorAll('[data-sheetcalc]').forEach(function (root) {
    var SW = parseFloat(root.getAttribute('data-sheet-w')) || 33;
    var SH = parseFloat(root.getAttribute('data-sheet-h')) || 48;
    var MG = parseFloat(root.getAttribute('data-margin')) || 0.5;
    var GU = parseFloat(root.getAttribute('data-gutter')) || 0.2;
    var PRICE = parseFloat(root.getAttribute('data-sheet-price')) || 15;
    var CUR = root.getAttribute('data-currency') || 'QAR';

    var wIn = root.querySelector('[data-sc-w]');
    var hIn = root.querySelector('[data-sc-h]');
    var qIn = root.querySelector('[data-sc-q]');
    var elPer = root.querySelector('[data-sc-per]');
    var elSheets = root.querySelector('[data-sc-sheets]');
    var elEach = root.querySelector('[data-sc-each]');
    var elTotal = root.querySelector('[data-sc-total]');
    var elNote = root.querySelector('[data-sc-note]');
    var elSvg = root.querySelector('[data-sc-svg]');
    var elCap = root.querySelector('[data-sc-vizcap]');
    var elWa = root.querySelector('[data-sc-wa]');
    var waNumber = root.getAttribute('data-whatsapp') || '97466007008';

    var UW = SW - 2 * MG, UH = SH - 2 * MG;

    function fitCount(a, b) {
      var cols = Math.floor((UW + GU) / (a + GU));
      var rows = Math.floor((UH + GU) / (b + GU));
      return { n: Math.max(0, cols) * Math.max(0, rows), cols: cols, rows: rows, w: a, h: b };
    }
    function bestFit(w, h) {
      var a = fitCount(w, h), b = fitCount(h, w);
      return b.n > a.n ? b : a;
    }
    function money(n) {
      return CUR + ' ' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function drawSheet(fit) {
      var scale = 300 / SH;  // cm -> px
      var w = SW * scale, h = SH * scale;
      var cells = '';
      var max = Math.min(fit.n, 400); // don't draw thousands of rects
      var i = 0;
      for (var r = 0; r < fit.rows && i < max; r++) {
        for (var c = 0; c < fit.cols && i < max; c++) {
          var x = (MG + c * (fit.w + GU)) * scale;
          var y = (MG + r * (fit.h + GU)) * scale;
          cells += '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + (fit.w * scale).toFixed(1) +
                   '" height="' + (fit.h * scale).toFixed(1) + '" rx="1.5" fill="#2757FF" fill-opacity=".16" stroke="#2757FF" stroke-width=".8"/>';
          i++;
        }
      }
      return '<svg viewBox="0 0 ' + w.toFixed(1) + ' ' + h.toFixed(1) + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Sheet layout preview">' +
        '<rect x="0" y="0" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" fill="#fff" stroke="#00061A" stroke-width="1.2"/>' +
        '<rect x="' + (MG * scale).toFixed(1) + '" y="' + (MG * scale).toFixed(1) + '" width="' + (UW * scale).toFixed(1) +
        '" height="' + (UH * scale).toFixed(1) + '" fill="none" stroke="#00061A" stroke-opacity=".18" stroke-width=".8" stroke-dasharray="4 3"/>' +
        cells + '</svg>';
    }

    function render() {
      var w = Math.max(1, parseFloat(wIn.value) || 0);
      var h = Math.max(1, parseFloat(hIn.value) || 0);
      var q = Math.max(1, parseInt(qIn.value, 10) || 1);

      if (w > UW && h > UW) {
        elPer.textContent = '—';
        elSheets.textContent = '—';
        elEach.textContent = '—';
        elTotal.textContent = '—';
        elNote.textContent = 'That item is larger than a ' + SW + ' × ' + SH + ' cm sheet. Ask us about oversize printing.';
        elSvg.innerHTML = '';
        elCap.textContent = '';
        return;
      }

      var fit = bestFit(w, h);
      if (fit.n < 1) {
        elPer.textContent = '0';
        elNote.textContent = 'That size does not fit on the sheet. Try rotating it or reducing one dimension.';
        elSheets.textContent = '—'; elEach.textContent = '—'; elTotal.textContent = '—';
        elSvg.innerHTML = ''; elCap.textContent = '';
        return;
      }

      var sheets = Math.ceil(q / fit.n);
      var total = sheets * PRICE;
      var each = total / q;
      var capacity = sheets * fit.n;
      var spare = capacity - q;

      elPer.textContent = fit.n;
      elSheets.textContent = sheets;
      elEach.textContent = money(each);
      elTotal.textContent = money(total);
      elNote.textContent = spare > 0
        ? 'Rounded up to a whole sheet — you get ' + spare + ' spare ' + (spare === 1 ? 'piece' : 'pieces') + ' free. Ordering ' + capacity + ' costs the same.'
        : 'Exactly ' + sheets + ' full ' + (sheets === 1 ? 'sheet' : 'sheets') + ' — no waste.';
      elSvg.innerHTML = drawSheet(fit);
      elCap.textContent = fit.cols + ' across × ' + fit.rows + ' down on a ' + SW + ' × ' + SH + ' cm sheet' +
        (fit.w !== w ? ' (rotated 90°)' : '');

      if (elWa) {
        var msg = 'Hi YouPrint, I would like a quote: ' + w + ' × ' + h + ' cm, quantity ' + q +
          ' (' + fit.n + ' per sheet, ' + sheets + ' sheets, ' + money(total) + ').';
        elWa.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
      }
    }

    [wIn, hIn, qIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', render);
      el.addEventListener('change', render);
    });
    render();
  });
})();

/* ==========================================================================
   YouPrint — size & quantity picker sheet
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-picker]').forEach(function (picker) {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var fmt = form.getAttribute('data-money-format') || '{{amount}}';
    var sizeSel = document.getElementById(picker.getAttribute('data-size-select'));
    var qtySel = document.getElementById(picker.getAttribute('data-qty-select'));
    if (!sizeSel || !qtySel) return;

    var sizeIdx = parseInt(sizeSel.getAttribute('data-option-index'), 10);
    var qtyIdx = parseInt(qtySel.getAttribute('data-option-index'), 10);
    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));

    var trigger = document.querySelector('[data-picker-open]');
    var sizesBox = picker.querySelector('[data-picker-sizes]');
    var qtyBox = picker.querySelector('[data-picker-qty]');
    var footTotal = picker.querySelector('[data-picker-total]');
    var footUnit = picker.querySelector('[data-picker-unit]');
    var sumGlyph = document.querySelector('[data-picker-summary-glyph]');
    var sumSize = document.querySelector('[data-picker-summary-size]');
    var sumQty = document.querySelector('[data-picker-summary-qty]');
    var sumTotal = document.querySelector('[data-picker-summary-total]');
    var sumUnit = document.querySelector('[data-picker-summary-unit]');
    var lastFocus = null;
    var PER = picker.getAttribute('data-per-piece') || 'piece';

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace('{{amount}}', v).replace('{{amount_with_comma_separator}}', v);
    }
    function parseQty(str) {
      var m = String(str).replace(/,/g, '').match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    }
    function fmtCm(n) {
      var r = Math.round(n * 10) / 10;
      return r % 1 === 0 ? r.toFixed(0) : r.toFixed(1);
    }
    function parseDims(str) {
      var n = String(str).replace(/[×✕✖]/g, 'x').replace(/\s+/g, ' ');
      var mm = /\bmm\b/i.test(n);
      var c = function (x) { return mm ? x / 10 : x; };
      var m = n.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (m) return [c(+m[1]), c(+m[2]), c(+m[3])];
      var d = n.match(/[Øø]\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (d) return [c(+d[1]), c(+d[1]), c(+d[2])];
      var f = n.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
      if (f) return [c(+f[1]), c(+f[2]), 0];
      return null;
    }
    function options() {
      var o = [];
      selects.forEach(function (s) { o[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      return o;
    }
    function findVariant(overrides) {
      var want = options();
      if (overrides) Object.keys(overrides).forEach(function (k) { want[k] = overrides[k]; });
      return variants.filter(function (v) {
        return want.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }

    /* proportional box glyph — the visual size reference */
    var maxSpan = 1;
    Array.prototype.forEach.call(sizeSel.options, function (o) {
      var d = parseDims(o.value);
      if (d) maxSpan = Math.max(maxSpan, d[0], d[1], d[2]);
    });

    function glyph(value, big) {
      var d = parseDims(value);
      var VB = 100, pad = 8;
      if (!d) {
        return '<svg viewBox="0 0 100 100" aria-hidden="true"><rect x="26" y="26" width="48" height="48" rx="5" ' +
               'fill="#DCE8F7" stroke="#12244A" stroke-width="2"/></svg>';
      }
      var scale = (VB - pad * 2) / maxSpan;
      var L = Math.max(6, d[0] * scale), W = Math.max(4, d[1] * scale), H = Math.max(6, (d[2] || d[1]) * scale);
      // simple isometric-ish footprint: front face L×H with a depth sliver
      var depth = Math.min(W * 0.42, 22);
      var totalW = L + depth, totalH = H + depth * 0.55;
      var ox = (VB - totalW) / 2, oy = (VB - totalH) / 2 + depth * 0.55;
      var f = 'M' + ox + ' ' + oy + 'h' + L + 'v' + H + 'h' + (-L) + 'z';
      var top = 'M' + ox + ' ' + oy + 'l' + depth + ' ' + (-depth * 0.55) + 'h' + L + 'l' + (-depth) + ' ' + (depth * 0.55) + 'z';
      var side = 'M' + (ox + L) + ' ' + oy + 'l' + depth + ' ' + (-depth * 0.55) + 'v' + H + 'l' + (-depth) + ' ' + (depth * 0.55) + 'z';
      var sw = big ? 2 : 2.4;
      return '<svg viewBox="0 0 100 100" aria-hidden="true">' +
        '<path d="' + f + '" fill="#DCE8F7" stroke="#12244A" stroke-width="' + sw + '" stroke-linejoin="round"/>' +
        '<path d="' + top + '" fill="#EEF4FC" stroke="#12244A" stroke-width="' + sw + '" stroke-linejoin="round"/>' +
        '<path d="' + side + '" fill="#C6D8EE" stroke="#12244A" stroke-width="' + sw + '" stroke-linejoin="round"/>' +
        '</svg>';
    }

    function renderSizes() {
      var html = '';
      Array.prototype.forEach.call(sizeSel.options, function (o) {
        var v = findVariant((function () { var x = {}; x[sizeIdx] = o.value; return x; })());
        var per = '';
        if (v) {
          var q = parseQty(qtySel.value);
          per = money(v.price / q) + ' / ' + PER;
        }
        var d = parseDims(o.value);
        var dims = d ? (d[2] ? fmtCm(d[0]) + ' × ' + fmtCm(d[1]) + ' × ' + fmtCm(d[2]) + ' cm' : fmtCm(d[0]) + ' × ' + fmtCm(d[1]) + ' cm') : '';
        var label = o.value.split('—')[0].trim() || o.value;
        html += '<button type="button" class="size-card" data-size-value="' + o.value.replace(/"/g, '&quot;') + '"' +
                ' aria-pressed="' + (o.value === sizeSel.value ? 'true' : 'false') + '">' +
                '<span class="size-card__glyph">' + glyph(o.value) + '</span>' +
                '<span class="size-card__name">' + label + '</span>' +
                (dims ? '<span class="size-card__dims">' + dims + '</span>' : '') +
                (per ? '<span class="size-card__price">' + per + '</span>' : '') +
                '</button>';
      });
      sizesBox.innerHTML = html;
    }

    function renderQty() {
      var html = '';
      var base = null;
      Array.prototype.forEach.call(qtySel.options, function (o) {
        var v = findVariant((function () { var x = {}; x[qtyIdx] = o.value; return x; })());
        if (!v) return;
        var q = parseQty(o.value);
        var unit = v.price / q;
        if (base === null) base = unit;
        var save = base > 0 ? Math.round((1 - unit / base) * 100) : 0;
        html += '<button type="button" class="qty-card" data-qty-value="' + o.value.replace(/"/g, '&quot;') + '"' +
                ' aria-pressed="' + (o.value === qtySel.value ? 'true' : 'false') + '">' +
                '<span class="qty-card__radio"></span>' +
                '<span class="qty-card__label">' + o.value + '</span>' +
                '<span class="qty-card__unit">' + money(unit) + ' / ' + PER + '</span>' +
                '<span class="qty-card__total">' + money(v.price) +
                (save >= 5 ? '<span class="qty-card__save">-' + save + '%</span>' : '') + '</span>' +
                '</button>';
      });
      qtyBox.innerHTML = html;
    }

    function renderTotals() {
      var v = findVariant();
      if (!v) return;
      var q = parseQty(qtySel.value);
      if (footTotal) footTotal.textContent = money(v.price);
      if (footUnit) footUnit.textContent = q > 1 ? money(v.price / q) + ' / ' + PER : '';
      if (sumSize) sumSize.textContent = sizeSel.value;
      if (sumQty) sumQty.textContent = qtySel.value;
      if (sumTotal) sumTotal.textContent = money(v.price);
      if (sumUnit) sumUnit.textContent = q > 1 ? money(v.price / q) + ' / ' + PER : '';
      if (sumGlyph) sumGlyph.innerHTML = glyph(sizeSel.value, true);
    }

    function refresh() { renderSizes(); renderQty(); renderTotals(); }

    function open() {
      lastFocus = document.activeElement;
      refresh();
      picker.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = picker.querySelector('.size-card, .qty-card, [data-picker-close]');
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      picker.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    if (trigger) trigger.addEventListener('click', open);
    picker.querySelectorAll('[data-picker-close], [data-picker-done]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !picker.hidden) close();
    });

    picker.addEventListener('click', function (e) {
      var sc = e.target.closest('[data-size-value]');
      if (sc) {
        sizeSel.value = sc.getAttribute('data-size-value');
        sizeSel.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
        return;
      }
      var qc = e.target.closest('[data-qty-value]');
      if (qc) {
        qtySel.value = qc.getAttribute('data-qty-value');
        qtySel.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      }
    });

    // keep the summary in step with the inline tier table
    selects.forEach(function (s) { s.addEventListener('change', renderTotals); });
    form.querySelectorAll('[data-tier-value]').forEach(function (row) {
      row.addEventListener('click', function () { setTimeout(renderTotals, 0); });
    });

    refresh();
  });
})();

/* ==========================================================================
   YouPrint — order delivery estimate (customer account)
   ========================================================================== */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-order-eta]');
  if (!els.length) return;

  function addWorkingDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 5 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en-GB',
        { day: 'numeric', month: 'short' });
    } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  els.forEach(function (el) {
    var from = el.getAttribute('data-from');
    if (!from) return;
    var start = new Date(from + 'T00:00:00');
    if (isNaN(start.getTime())) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 8;
    var max = parseInt(el.getAttribute('data-max'), 10) || 12;
    var ship = parseInt(el.getAttribute('data-ship'), 10) || 2;
    var a = addWorkingDays(start, min);
    var b = addWorkingDays(addWorkingDays(start, max), ship);
    var label = el.getAttribute('data-label') || '';
    el.textContent = (label ? label + ' ' : '') + fmt(a) + ' – ' + fmt(b);
  });
})();
